export default (date) => Math.floor(date.getTime() / 1000);
